module.exports = __webpack_public_path__ + "media/images/project/currency-8b493f09004d142bc123aa5f7a635b18.svg";